var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "editErrorModal",
            size: "lg",
            "content-class": "menu-bg-blue-transparent-modal",
            title: "Delivery Review Tool Update Error",
            "hide-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function ({ close }) {
                return [
                  _c("div", { staticClass: "ae-header" }, [
                    _c(
                      "span",
                      { staticClass: "ae-header-icon" },
                      [_c("fa", { attrs: { icon: ["fas", "pencil-alt"] } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "ae-header-text" }, [
                      _c("h5", { staticClass: "ae-title" }, [
                        _vm._v("Update Error"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "ae-subtitle" }, [
                        _vm._v("Review and update error details"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ae-close",
                        attrs: { type: "button", title: "Close" },
                        on: {
                          click: function ($event) {
                            return close()
                          },
                        },
                      },
                      [_c("fa", { attrs: { icon: ["fas", "times"] } })],
                      1
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm.updateErrorDataSource
            ? _c(
                "b-container",
                [
                  _c(
                    "div",
                    { staticClass: "ae-info" },
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "pt-1",
                          attrs: { "align-h": "start", "no-gutters": "" },
                        },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Error ID: "),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "data-font",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.updateErrorDataSource.id)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.updateErrorDataSource &&
                          _vm.updateErrorDataSource.region
                            ? _c(
                                "b-col",
                                { attrs: { cols: "6", "no-gutters": "" } },
                                [
                                  _c(
                                    "b-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _vm._v("Region: "),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "data-font",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.updateErrorDataSource.region
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          staticClass: "pt-1",
                          attrs: { "align-h": "start", "no-gutters": "" },
                        },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Submitted By: "),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "data-font",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.updateErrorDataSource.created_user
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.updateErrorDataSource &&
                          (_vm.updateErrorDataSource.country ||
                            _vm.updateErrorDataSource.province)
                            ? _c(
                                "b-col",
                                { attrs: { cols: "6", "no-gutters": "" } },
                                [
                                  _c(
                                    "b-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _vm._v("Country,Province: "),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "data-font",
                                          attrs: { cols: "8" },
                                        },
                                        [_vm._v(_vm._s(_vm.locationTag))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          staticClass: "pt-1",
                          attrs: { "align-h": "start", "no-gutters": "" },
                        },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Submitted Date: "),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "data-font",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            _vm.updateErrorDataSource
                                              .created_date
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.updateErrorDataSource &&
                          _vm.updateErrorDataSource.lat_lon
                            ? _c(
                                "b-col",
                                { attrs: { cols: "6", "no-gutters": "" } },
                                [
                                  _c(
                                    "b-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _vm._v("LAT/LON: "),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "data-font",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.updateErrorDataSource.lat_lon
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          staticClass: "pt-1",
                          attrs: { "align-h": "start", "no-gutters": "" },
                        },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Updated By: "),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "data-font",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.updateErrorDataSource.updated_user
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "6", "no-gutters": "" } },
                            [
                              _c(
                                "b-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _vm._v("Update Date: "),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "data-font",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            _vm.updateErrorDataSource
                                              .updated_date
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-4" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", [_vm._v(" Layer: ")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.updateErrorDataSource.layer_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateErrorDataSource,
                                  "layer_name",
                                  $$v
                                )
                              },
                              expression: "updateErrorDataSource.layer_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("label", [_vm._v(" Dataset: ")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.updateErrorDataSource.dataset,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateErrorDataSource,
                                  "dataset",
                                  $$v
                                )
                              },
                              expression: "updateErrorDataSource.dataset",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("label", [_vm._v(" PDT Issue ID: ")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: _vm.isExpired },
                            model: {
                              value: _vm.updateErrorDataSource.issue_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateErrorDataSource,
                                  "issue_id",
                                  $$v
                                )
                              },
                              expression: "updateErrorDataSource.issue_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-2" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", [_vm._v(" Layer Attribute: ")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.updateErrorDataSource.layer_attribute,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateErrorDataSource,
                                  "layer_attribute",
                                  $$v
                                )
                              },
                              expression:
                                "updateErrorDataSource.layer_attribute",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("label", [_vm._v(" Error Type: ")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.updateErrorDataSource.error_type,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateErrorDataSource,
                                  "error_type",
                                  $$v
                                )
                              },
                              expression: "updateErrorDataSource.error_type",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("label", [_vm._v(" Severity: ")]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: {
                              options: _vm.severityOptions,
                              disabled: _vm.isExpired,
                            },
                            model: {
                              value: _vm.updateErrorDataSource.severity,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateErrorDataSource,
                                  "severity",
                                  $$v
                                )
                              },
                              expression: "updateErrorDataSource.severity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-2" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", [_vm._v(" Comments: ")]),
                          _vm._v(" "),
                          _c("b-form-textarea", {
                            attrs: { rows: "2", disabled: "" },
                            model: {
                              value: _vm.updateErrorDataSource.comments,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateErrorDataSource,
                                  "comments",
                                  $$v
                                )
                              },
                              expression: "updateErrorDataSource.comments",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-2" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", [_vm._v(" Status: ")]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: {
                              options: _vm.statusOptions,
                              disabled: _vm.isExpired,
                            },
                            model: {
                              value: _vm.updateErrorDataSource.status,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateErrorDataSource,
                                  "status",
                                  $$v
                                )
                              },
                              expression: "updateErrorDataSource.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-2" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", [_vm._v(" Notes: ")]),
                          _vm._v(" "),
                          _c("b-form-textarea", {
                            attrs: { rows: "5", disabled: _vm.isExpired },
                            model: {
                              value: _vm.updateErrorDataSource.notes,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateErrorDataSource,
                                  "notes",
                                  $$v
                                )
                              },
                              expression: "updateErrorDataSource.notes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-3" },
                    [
                      _c("b-col", [
                        _c("label", [_vm._v("Snapshots")]),
                        _vm._v(" "),
                        _vm.loadingSnapshots
                          ? _c(
                              "div",
                              { staticClass: "text-center py-2" },
                              [_c("b-spinner", { attrs: { small: "" } })],
                              1
                            )
                          : _vm.snapshots.length
                          ? _c(
                              "div",
                              { staticClass: "snapshot-gallery" },
                              _vm._l(_vm.snapshots, function (snap) {
                                return _c("img", {
                                  key: snap.id,
                                  staticClass: "snapshot-thumb",
                                  attrs: {
                                    src: _vm.snapshotUrl(snap.path),
                                    title:
                                      snap.created_user +
                                      " · " +
                                      _vm.formatDate(snap.created_date),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openSnapshot(snap.path)
                                    },
                                  },
                                })
                              }),
                              0
                            )
                          : _c(
                              "div",
                              { staticClass: "text-muted small py-1" },
                              [_vm._v("No snapshots saved for this error.")]
                            ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-2" },
                    [
                      _c("b-col", [
                        _c(
                          "button",
                          {
                            staticClass: "drt-update-btn",
                            attrs: { disabled: _vm.isExpired },
                            on: {
                              click: function ($event) {
                                return _vm.updateError()
                              },
                            },
                          },
                          [_c("span", [_vm._v("Update Error")])]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }